<template>
  <div id="footer">
    <section class="max-w-6xl mx-auto p-4">
			
    </section>
  </div>
</template>
